// import React,{useState} from "react";
import React, { Component } from "react";

import {
  RangeDatePicker,
  SingleDatePicker
} from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import { withRouter } from "react-router-dom";
import {connect } from 'react-redux';
import moment from "moment";
import {date} from '../../slices/dateSlice'

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: this.props.startDate || new Date(),
      endDate: this.props.endDate || new Date(),
    };
    this.onchangeDate = this.onchangeDate.bind(this);
  }

  onchangeDate(start, end) {
    const startDate = moment(start).format('YYYY-MM-DD')
    const endDate = moment(end).format('YYYY-MM-DD')
    const num = this.props.num
    this.props.dispatch(date(
      {
       startDate, endDate, num
    }
    ));
  }
  render() {
    const returnBool = this.props.returnBool;
    return (
      <div>
        {returnBool &&
          <div>
            <RangeDatePicker
              startDate={this.props.startDate || new Date()}
              endDate={this.props.endDate || new Date()}
              onChange={(startDate, endDate,num) =>
                this.onchangeDate(startDate, endDate)
              }
              singleCalendar={true}
              minDate={new Date()}
            />
          </div>
        }

        {!returnBool && 
        <div>
          <SingleDatePicker
            startDate={this.props.startDate || new Date()}
            endDate={this.props.endDate || new Date()}
            onChange={(startDate, endDate) =>
              this.onchangeDate(startDate, endDate)
            }
            singleCalendar={true}
          />
        </div>
        }

      </div>
    );
  }
}
 

function mapStateToProps(state) {
  return {
    startDate: state.date.startDate[0],
    endDate: state.date.endDate[0],
  }
}
//connect function INJECTS dispatch function as a prop!!
// export default connect(mapStateToProps)(AdvencedSearchGhurfaty);
export default withRouter(connect(mapStateToProps)(Calendar));



